import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Set target="_blank" only if page is in an iframe
    if (window.self !== window.top) {
      this.element.target = "_blank";
    }
  }
}
